// @ts-check
import React from 'react';
import styled from 'styled-components';

const OverlayWrapper = styled.div`
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  background-color: rgba(33, 48, 56, 0.75);
  z-index: 99;
  opacity: 0.9;

  @media ${({ theme }) => theme.breakpoints.desktop} {
    z-index: 10;
  }

  &.overlay-transition-enter {
    opacity: 0;
  }

  &.overlay-transition-enter-active {
    opacity: 0.9;
    transition: opacity 200ms ease-out;
  }

  &.overlay-transition-exit {
    opacity: 0.9;
  }

  &.overlay-transition-exit-active {
    opacity: 0;
    transition: opacity 200ms ease-in;
  }
`;

const Overlay = props => <OverlayWrapper onClick={props.onClick} />;

export default Overlay;
